import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const CuriousCatIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_572_10706)">
        <path
          d="M0.998291 22H22.9983"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.93585 18.3077V18.7692M4.99829 22V10.5L8.93585 13.7308H15.0608L18.9983 10.5V22M15.0608 18.3077V18.7692"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.49829 3.30324C9.70568 2.702 10.115 2.19502 10.6538 1.87208C11.1927 1.54915 11.8262 1.4311 12.4421 1.53885C13.0581 1.6466 13.6168 1.97319 14.0193 2.46078C14.4218 2.94837 14.6421 3.56549 14.6411 4.20284C14.6411 6.00205 11.9947 6.90165 11.9947 6.90165M12.0652 10.5H12.0741"
          stroke="var(--cdl-chart-orange-base)"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_572_10706">
          <rect
            width="24"
            height="24"
            fill="var(--cdl-bg-base)"
            transform="translate(-0.00170898)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CuriousCatIcon;
